<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide11',
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 9200,
          end: 9600,
          fromStyle: { transform: 'translateY(-1700px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(150px) rotateZ(-6deg)' },
          easing: 'linear'
        },
        {
          start: 10500,
          end: 11000,
          fromStyle: { transform: 'translateY(151px) rotateZ(-6deg)' },
          toStyle: { transform: 'translateY(2000px) rotateZ(-6deg)' },
          easing: 'linear'
        },
      ]
    };
  },
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/6a.jpg',
          url: 'https://endhomelessness.org/homelessness-in-america/what-causes-homelessness/inequality/',
          link_title: {
			'en': 'Homelessness and Racial Disparities',
			'es': 'Falta de vivienda y disparidades raciales'
		  }
        },
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/6b.jpg',
          url: 'https://vimeo.com/328684375',
          link_title: {
			'en': 'Segregated By Design',
			'es': 'Segregado por diseño'
		  }
        },
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/6c.jpg',
          url: 'https://dsl.richmond.edu/panorama/renewal/#view=0/0/1&viz=cartogram',
          link_title: {
			'en': 'Renewing Inequality',
			'es': 'Renovación de la desigualdad'
		  }
        }
      ],
      text: {
		'en': 'Two of the main causes of homelessness are sudden loss of income, and major health issues. African Americans and other minority groups have historically struggled to acquire housing and keep their housing due racist institutional practices such as redlining, urban renewal, healthcare discrimination, employment discrimination and wage discrimination.',
		'es': 'Dos de las principales causas de la falta de vivienda son la pérdida repentina de ingresos y los principales problemas de salud. Históricamente, los afroamericanos y otros grupos minoritarios han luchado para adquirir una vivienda y conservarla debido a prácticas institucionales racistas, como las líneas rojas, la renovación urbana, la discriminación en el cuidado de la salud, la discriminación en el empleo y la discriminación salarial.'
	  }
    };

    const text = {
		'en': 'As a result of institutional racism and the right combination of unfortunate life events, Black Americans and other people of color are far more susceptible to losing their homes. ABC News reported in 2019 that, “an estimated 568,000 Americans experienced homelessness, with African Americans making up about 40% of that total.”',
		'es': 'Como resultado del racismo institucional y la combinación correcta de eventos desafortunados de la vida, los afroamericanos y otras personas de color son mucho más susceptibles de perder sus hogares. ABC News informó en 2019 que, "aproximadamente 568,000 estadounidenses sin hogar, y los afroamericanos representan aproximadamente el 40% de ese total".'
	}
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(150px) rotateZ(-6deg)') {
          this.$readMore.value = text;
          this.$evidence.value = JSON.stringify(evidence);
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide11'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/11_Hospital.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 750px;
    height: 600px;
    left: -370px;
    top: 28vh;
    transition: 0.7s;
    z-index: 5;
    @media(max-width: 600px) {
      width: 310px;
      left: -130px;
      top: calc(50% - 400px);
    }
}
</style>
